import { openTelegramLink } from "@telegram-apps/sdk-react";
import { Button, Placeholder } from "@telegram-apps/telegram-ui";
import React from "react";
import { useTranslation } from "react-i18next";
import LottieSticker from "~/components/LottieSticker";
import { Page } from "~/components/Page/Page";
import { config } from "~/config";

const GoOffline: React.FC = () => {
    const { t } = useTranslation();

    const handleGotoUxuy = () => {
        openTelegramLink(`${config.wallet_direct_link}?startapp=P_trade`)
    }

    return (
        <Page>
            <Placeholder
                className="py-20"
                header={
                    <span className="text-text_1 text-h4">
                        {t("go_offline_title")}
                    </span>
                }
                description={
                    <p className="text-text_2 text-body1 whitespace-pre-line">
                        {t("go_offline_text")}
                    </p>
                }
                action={
                    <Button
                        color="white"
                        style={
                            {
                                width: "80%",
                                height: 54,
                                borderRadius: "12px",
                                borderColor: "transparent",
                                textColor: "var(--White)",
                                backgroundColor: `var(--color_text_brand)`,
                            } as React.CSSProperties
                        }
                        onClick={handleGotoUxuy}
                    >
                        <span className="flex items-center justify-center text-h6 font-semibold">
                            {t("go_offline_btn")}
                        </span>
                    </Button>
                }
            >
                <LottieSticker lottieName="uxuy-flag" className="w-[120px] h-[120px]" />
            </Placeholder>
        </Page>
    );
};

export default GoOffline;
